import { Box, Grid } from '@mui/material';
import { useState } from 'react';
import { InputText } from '@/components/shared/InputText';
import { useTranslation } from 'react-i18next';
import { useNotificationsSnackbar } from '@/components/snackbar/NotificationsSnackbarContext';
import { useErrorHandling } from '@/utils/errorHandling';
import { useAppDispatch, usePayments } from '@/lib/hooks';
import { intectAuthorizeSetup } from '@/lib/slices/paymentsSlice';
import { FETCH_STATE } from '@/lib/slices/types';
import {
    PrimaryButtonStyle,
    SecondaryButtonStyle
} from '@/pages/company/common/IntegrationDialog';
import { useHandleResponse } from '@/lib/hooks/useHandleResponse';
interface IntectConnectProps {
    onClose?: () => void;
    onSaveSuccess: any;
    IntectButtonTitle?: any;
}

export const IntectConnect = (props: IntectConnectProps) => {
    const { t } = useTranslation();
    const [intectUsername, setIntectUsername] = useState<string>('');
    const [intectPassword, setIntectPassword] = useState<string>('');
    const { setAlert } = useNotificationsSnackbar();
    const { backendErrorHandler } = useErrorHandling();
    const dispatch = useAppDispatch();
    const { intectAuthorizeState } = usePayments();

    const isLoading = intectAuthorizeState.status === FETCH_STATE.LOADING;

    useHandleResponse({
        error: intectAuthorizeState.error,
        isPending: isLoading,
        isSuccess: intectAuthorizeState.status === FETCH_STATE.SUCCEEDED,
        successAlertMessage: t('authorized_successfully'),
        isSuccessCallBack: props.onSaveSuccess
    });

    const onClick = () => {
        dispatch(
            intectAuthorizeSetup({
                username: intectUsername,
                password: intectPassword
            })
        );
    };

    return (
        <>
            <Box width={'100%'} margin={'20px 0 10px'}>
                <InputText
                    value={intectUsername}
                    label={t('username')}
                    onChange={(e) => {
                        setIntectUsername(e.target.value);
                    }}
                    spacing="10px 0"
                />

                <InputText
                    value={intectPassword}
                    label={t('password')}
                    onChange={(e) => {
                        setIntectPassword(e.target.value);
                    }}
                    spacing="10px 0"
                />
            </Box>

            <Grid m={'20px 0'} container justifyContent={'space-around'}>
                <SecondaryButtonStyle
                    onClick={props.onClose}
                    sx={{ width: '170px' }}
                >
                    {t('back')}
                </SecondaryButtonStyle>

                <PrimaryButtonStyle
                    onClick={onClick}
                    sx={{ width: '170px' }}
                    loading={isLoading}
                    disabled={!intectUsername || !intectPassword}
                >
                    {props?.IntectButtonTitle
                        ? props?.IntectButtonTitle
                        : t('connect')}
                </PrimaryButtonStyle>
            </Grid>
        </>
    );
};
